import { atom } from 'recoil';

export const customQueriesAtom = atom({
  key: 'customQueriesAtom',
  default: {
    loading: false,
    item: null,
    items: [],
    error: null
  },
});